import locationPill from '../../renderers/location_pill'

export default (() => {
  class Location {
    constructor(location, pill) {
      this.location = location
      this.pill = pill || locationPill(location)
      this.isHome = location?.isHome
      this.isUHomeLoc = location?.isUHomeLoc
      this.homeLocationIcon = this.pill?.querySelector('.home-location')
    }

    setActive() {
      this.pill.classList.add('active')
      this.location.isActive = true
    }

    setInactive() {
      this.pill.classList.remove('active')
      this.location.isActive = false
    }

    removedDetectedIcon() {
      const locationStatus = this.pill?.querySelector('.detected-location')?.classList
      if (!locationStatus?.contains('display-hidden')) {
        locationStatus?.add('display-hidden')
      }
    }

    setHomeLocation() {
      this.isUHomeLoc = true
      this.isHome = true
      this.location.isUHomeLoc = true
      this.location.isHome = true
      this.removedDetectedIcon()
      this.homeLocationIcon?.classList?.remove('display-hidden')
    }

    removeHomeLocation() {
      this.isUHomeLoc = false
      this.isHome = false
      this.location.isUHomeLoc = false
      this.location.isHome = false
      this.removedDetectedIcon()
      this.homeLocationIcon?.classList?.add('display-hidden')
    }

    showCrossBtn() {
      this.crossBtn?.classList.remove('display-hidden')
    }

    hideCrossBtn() {
      this.crossBtn?.classList.add('display-hidden')
    }

    addCrossBtnClass() {
      this.pill.classList.add('hasCrossBtn')
    }

    removeCrossBtnClass() {
      this.pill.classList.remove('hasCrossBtn')
    }

    get isActive() {
      return this.pill.classList.contains('active') || this.location?.isActive
    }

    get getWoeid() {
      return this.location.woeid
    }

    get getPhotoWoeid() {
      return this.location.photoWoeid
    }

    get crossBtn() {
      return this.pill.querySelector('.default-btn__cross')
    }

    get hasCrossBtn() {
      return !this.crossBtn?.classList.contains('display-hidden')
    }
  }

  return Location
})()
